<template>
  <div class="new-application">
    <el-card class="box-card">
      <folded-panel infoName="基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="false"
            :disabled="!isEdit"
            ref="form"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="项目阶段计划">
        <div slot="content">
          <edit-data-table
            :head="tableHead"
            :data.sync="tableData"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :edit-rules="validRules"
            :editable="isEdit"
            :showAdd="isEdit"
            height=""
            ref="projectStage"
          >
            <template #code="{$index}">
              <span>{{$index+1}}</span>
            </template>
            <template #milestoneNodes="{row}">
              <span>{{row.milestoneNodes? row.milestoneNodes.name:''}}</span>
            </template>
            <template #milestoneNodesEdit="{row}">
              <data-box
                hostUrl="/bsMilestoneNode"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.milestoneNodes"
                @confirm="(val) => {row.milestoneNodes = val.id}"
              ></data-box>
            </template>
            <template #keyOutsList="{row}">
              <span v-for="(item, index) in row.keyOutsList" :key="item.id">{{item.name}}{{index &lt; row.keyOutsList.length-1 ? ',' : ''}}</span>
            </template>
            <template #keyOutsListEdit="{row}">
              <data-box
                hostUrl="/bsKeyOuts"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="true"
                v-model="row.keyOutsList"
                @confirm="(val) => {row.keyOutsList = val;const newArr = val.map((item) => { return item.id });row.keyOutput = newArr.join()? newArr.join():null}"
              ></data-box>
            </template>
            <template #toolbar="scope">
              <span v-if="!isEdit">无</span>
               <el-popover :ref="scope.$index + 'a'" placement="top" width="180" v-if="isEdit">
                <p>确定删除本条数据吗？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="$refs[scope.$index + 'a'].doClose()">取消</el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="delMilestonePlans(scope.row.id,scope)">确定
                  </el-button>
                </div>
                <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
              </el-popover>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="btn-warp">
          <!-- <el-button class="btn-cancel" v-if="isEdit" :loading="loading" @click="save(1)">保存</el-button> -->
        <el-button class="btn-submit" v-if="isEdit" :loading="loading" @click="submit(1)">提交</el-button>
        <el-button class="btn-cancel" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import { addForm, idQuery } from "@/api/basic/projectPhase";
import { deepClone } from "@/utils";
import {getDocumentCode} from '@/views/utils'
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import CrudMixin from "@/mixins/CrudMixin";
import {tableSataus} from '@/views/bill/mixins/status'
import initDict from "@/mixin/initDict";

export default {
  name: "ProjectPhaseForm",
  components: { FoldedPanel, DataBox, },
  mixins: [CrudMixin,tableSataus,initDict],
  data() {
    return {
      preNodeList: [],
      keyOutsListArr: [],
      id: "",
      isEdit: false,
      loading: false,
      form: {deliveryId: ''},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8,
            disabled: true
          },
          {
            type: "input",
            key: "name",
            label: "模板名称",
            value: "",
            span: 8,
            disabled: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "select",
            key: "foundNumber",
            label: "模板类型",
            value: "",
            span: 8,
            disabled: false,
            options: [],
            rules: {
              required: true,
              message: "不能为空",
              trigger: "blur"
            }
          },
          {
            type: "date",
            key: "created",
            label: "提交日期",
            valueFormat: "yyyy-MM-dd",
            defaultValue: new Date(),
            span: 8,
            disabled: true
          },
          // {
          //   type: "date",
          //   key: "modified",
          //   label: "最后修改日期",
          //   placeholder: "最后修改日期",
          //   value: "",
          //   valueFormat: "yyyy-MM-dd",
          //   span: 8
          // }
        ]
      },
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      tableHead: [
        {
          label: "项目阶段编号",
          prop: "code"
        },
        {
          label: "项目阶段",
          prop: "milestoneNodes",
          editRender: { type: "default" },
        },
        // {
        //   label: "对应项目节点",
        //   prop: "bsProjectNode",
        //   editRender: { type: "default"}
        // },
        {
          label: "工作目标描述",
          prop: "workTargetDetail",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "关键输出物",
          prop: "keyOutsList",
          editRender: { type: "default" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData: [],
      projectStage: [
         { label: "项目阶段名称", property: "milestoneNodes.name", query: { type: "input" } },
          { label: "工作描述", property: "workTargetDetail"}
      ],
      projectNumber: '',
      validRules: {
        milestoneNodes: [{ required: true, message: "不能为空", trigger: "blur" }],
        keyOutsList: [{ required: true, message: "不能为空", trigger: "blur" }],
      },
      validateRefNames: ['form', 'projectStage']
    };
  },
  watch: {
  },
  created() {
    this.id = this.$route.query.id;
    this.isEdit = Boolean(parseInt(this.$route.query.isEdit));
    if (this.id) {
      idQuery(this.id).then(res => {
        if (res.code === 200) {
          this.form = res.data.bsProjectMilestone;
          this.tableData = res.data.bsProjectMilestonePlanList;
          this.tableData.forEach((item,index) => {
              item.milestoneNodes = { name: item.milestoneNodeName,id: item.milestoneNode}
          });
        }
      });
    } else {
       this.form.code = getDocumentCode('XNJDMB');
    }
    this.getDict("project_type").then(res => {
        this.formConfig.formItemList[this.formConfig.formItemList.findIndex(ele => ele.key === 'foundNumber')].options = res.data;
    });
  },
  methods: {
    // 插入行
    insertRow(scope) {
      const firstCode = scope.row.code.split('.')[0]
      let sameIndex, secondCode
      for (let i = scope.$index; i <= this.tableData.length; i++) {
          if (i === this.tableData.length || this.tableData[i].code.split('.')[0] !== firstCode) {
            secondCode = this.tableData[i - 1].code.split('.')[1]
            sameIndex = i
            break
         }
      }
      secondCode = parseInt(secondCode) + 1
      if (secondCode < 10) {
        secondCode = '0' + secondCode
      }
      this.tableData.splice(sameIndex, 0, {
        code: firstCode + '.' + secondCode,
        milestoneNodeEntity: scope.row.milestoneNodeEntity,
        milestoneNodes: scope.row.milestoneNodes,
        predictStartTime: scope.row.predictStartTime,
        lastCompletionTime: scope.row.lastCompletionTime,
        updata: "add"
      })
    },
    addPlan(data) {
      addForm(data).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.$notify({
            title: '操作成功！',
            type: 'success',
            duration: 2500
          })
         this.$router.go(-1);
        }
      });
    },
    // 保存
    save() {
       this.loading = true
      this.addPlan(this.getFormData())
    },
    // 提交
    submit() {
      this.loading = true
     this._validateForm(this.validateRefNames).then(() => {
      this.addPlan(this.getFormData(1))
     }).catch(e => { this.loading = false; })
    },
    cancel() {
       this.$router.go(-1);
    },
    statusFilter(val) {
      const arr = this.tableHead.filter(ele => ele.prop === "taskStatus");
      if (arr.length) {
        const labelArr = arr[0].editRender.options.filter(ele => ele.value === val);
        if (labelArr.length) {
          return labelArr[0].label;
        }
      }
    },
    // 组装提交数据
    getFormData(status = 1) {
        this.form.billState = status;
        const form = deepClone(this.form);
        this.tableData.forEach(ele => { ele.milestoneNode = ele.milestoneNodes.id })
        return {
            bsProjectMilestone: form,
            bsProjectMilestonePlanList: this.tableData,
        }
    },
     delMilestonePlans(id, scope) {
         this.tableData.splice(scope.$index, 1);
         this.$refs[scope.$index + 'a'].doClose()
    },
  }
};
</script>

<style lang="scss" scoped>
.el-upload-list__item{
  width:30%;
}
.file-box {
      margin-top: 10px;
      display: flex;
      position: relative;
      padding: 10px;
      .file-item{
        position: relative;
        margin-right: 14px;
        .file-close{
          position: absolute;
          left: 0px;
          top: -6px;
          font-size: 14px;
        }
      }
    }
.btn-warp {
  padding-top: 20px;
  text-align: right;

  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }

  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
